/** Product name inside tables: light outline, 4px radius. */
export function ProductTag({ name }: { name: string }) {
  return (
    <span className="inline-block whitespace-nowrap rounded-tag border border-border px-2 py-0.5 text-xs text-foreground-secondary">{name}</span>
  );
}
